/**
 * Paso9.js
 * @author Huarte Joaquin
 */

//Dependencies
import React, { Component } from 'react';
import { connect } from 'react-redux'
import axios from 'axios';
import $ from 'jquery';
import { onBoardingDigital } from '../../actions/actions';

//material-ui
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import green from '@material-ui/core/colors/green';
import { withStyles } from '@material-ui/core/styles';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

// Components
import Legal from './Legal';
import LegalStand from './LegalStand';

//Assets
import tyc from '../../static/img/tyc.png';

//Services
import { processToken } from './services/tokenService';
import { processFlow } from './services/flowService';
import { storeUrlRiesgoNet } from './services/riesgoNetService';
import { processIdClientAnalytics } from './services/pixelService';
import { Layout } from './layout/Layout';

let tipoFujo = sessionStorage.getItem('tipoFlujo')


class Paso9 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            paso: 9,
            /* disabledBtn: true, */
            checkedtyc:false,
            /* correo: "", */
            open: false,
            disabled : false
        }
        /* this.handleChange = this.handleChange.bind(this); */
        this.checkboxClick = this.checkboxClick.bind(this);
        this.ejecutarVenta = this.ejecutarVenta.bind(this);
        this.validateFlow = this.validateFlow.bind(this);
        this.validateToken = this.validateToken.bind(this);
        this.setSiguientePaso = this.setSiguientePaso.bind(this);
        this.handleDrawerOpen = this.handleDrawerOpen.bind(this);
        this.handleDrawerClose = this.handleDrawerClose.bind(this);
    }
    
    

    handleDrawerOpen = () => {
        processIdClientAnalytics('acepta-terminos');
        this.setState({ open: true });
        
    };

    handleDrawerClose = () => {
        this.setState({ open: false });
    };

    componentWillMount() {
        this.validateFlow();
        this.validateToken();
        processIdClientAnalytics('paso-9')
    }

    componentDidMount() {
        $(".load").fadeOut(700);
    }

    validateFlow() {
        processFlow(this.props.history, this.state.paso);
    }

    validateToken() {
        processToken(this.props.history)
    }

    setSiguientePaso() {
        this.props.dispatch(
            onBoardingDigital(this.state.paso + 1)
        );
    }

    checkboxClick(){
        this.setState({
            checkedtyc:!this.state.checkedtyc,
        })
    }

    ejecutarVenta() {
        this.setState({disabled : true})
        this.setSiguientePaso();
        return this.props.history.push('/cargando-venta')
    }

    render() {
        const { classes, theme } = this.props;
        const { open } = this.state;

        const footer = {
            button: {
                action : this.ejecutarVenta,
                text : "confirmar",
                disabled : !this.state.checkedtyc || this.state.disabled
            }
        };
        const body = {img : { src : tyc }}
        return (
            <Layout body={body} footer={footer} tieneFooter>                
                <Grid container
                    direction="row"
                    justify="center"
                    alignItems="center">
                        <Grid item xs={12}>
                            <div className="content-description">
                                <h5 className="title" >Listo, para finalizar aceptá</h5>
                                <h5 className="title">los Términos y Condiciones</h5>
                                <h6 className="description">Te los enviaremos adjuntos a tu email: 
                                <br/><strong>{this.props.correo}</strong></h6>
                            </div>
                        </Grid>
                        <Grid item xs={12}>

                        <Checkbox onClick={this.checkboxClick} 
                            classes={{
                                root: classes.root,
                                checked: classes.checked
                            }}
                            checked={this.state.checkedtyc}
                            icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                            checkedIcon={<CheckBoxIcon fontSize="small" />}
                            />
                        <span className="tyc">Acepto los <a onClick={this.handleDrawerOpen} href="#!" >Términos y Condiciones del producto </a> </span>y <span className="tyc"><a href="https://www.hipotecario.com.ar/personas/comisiones-cargos-y-tasas/" target="_blank">anexo</a></span>
                        </Grid>

                    <Drawer onClick={this.handleDrawerClose}
                        className={classes.drawer}
                        variant="persistent"
                        anchor="left"
                        open={open}
                        classes={{
                            paper: classes.drawerPaper,
                        }}
                        >
                        <div className={classes.drawerHeader}>
                            <IconButton onClick={this.handleDrawerClose}>
                                {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                            </IconButton>
                        </div>
                        
                        {sessionStorage.getItem('tipoFlujo') == 'standalone' ? <LegalStand/> : <Legal/>}
                            
                    </Drawer>
                </Grid>
            </Layout>
        );
    }
}

const styles = theme => ({
    root: {
        color: green[600],
        '&$checked': {
            color: green[500],
        },
        //display: 'flex',
    },
    checked: {},
    appBar: {
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginLeft: 12,
        marginRight: 20,
    },
    hide: {
        display: 'none',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
    },
    drawerHeader: {
        display: 'flex',
        alignItems: 'center',
        padding: '0 8px',
        ...theme.mixins.toolbar,
        justifyContent: 'flex-end',
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing.unit * 3,
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        marginLeft: -drawerWidth,
    },
    contentShift: {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: 0,
    },
});

const drawerWidth = 240;

const mapStateToProps = function (state) {
    return {
        nombre: state.usuario.nombre,
        correo: state.usuario.correo
    }
}

export default withStyles(styles, { withTheme: true })(connect(mapStateToProps)(Paso9));


// WEBPACK FOOTER //
// ./src/components/OnBoarding/Paso9.js